import { render } from "./SelectGoodResponse.vue?vue&type=template&id=5c600a17"
import script from "./SelectGoodResponse.vue?vue&type=script&lang=js"
export * from "./SelectGoodResponse.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Questionnaire/Question/SelectGoodResponse.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c600a17"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c600a17', __exports__)) {
    api.reload('5c600a17', __exports__)
  }
  
  module.hot.accept("./SelectGoodResponse.vue?vue&type=template&id=5c600a17", () => {
    api.rerender('5c600a17', render)
  })

}


export default __exports__